import {
	CAP_TABLE_NUMBER_FORMAT,
	CAP_TABLE_VALUE_DISPLAY_MODE,
	CAP_TABLE_VALUES_HELD_TYPE,
} from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/tableSettings.ts';
import type {
	CapChartLocalStorageSettings,
	CapChartStoredSettings,
} from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/capChartSettings.types.ts';

const VALUES_HELD_TYPE_ORDER = [
	CAP_TABLE_VALUES_HELD_TYPE.SECURITIES,
	CAP_TABLE_VALUES_HELD_TYPE.VOTES,
];

export const DEFAULT_CAP_CHART_SETTINGS: CapChartLocalStorageSettings = {
	valueDisplayMode: CAP_TABLE_VALUE_DISPLAY_MODE.ABSOLUTE,
	valuesHeldTypes: [CAP_TABLE_VALUES_HELD_TYPE.SECURITIES],
	numberFormat: CAP_TABLE_NUMBER_FORMAT.SHORTENED,
};

/** Units before votes, dropping anything that is not a known type. */
export const orderValuesHeldTypes = (types: readonly string[]): CAP_TABLE_VALUES_HELD_TYPE[] =>
	VALUES_HELD_TYPE_ORDER.filter((type) => types.includes(type));

/** Resolves persisted settings, including the legacy single-type shape, onto a complete set. */
export const parseStoredCapChartSettings = (
	stored: CapChartStoredSettings
): CapChartLocalStorageSettings => {
	const storedTypes =
		stored.valuesHeldTypes ?? (stored.valuesHeldType ? [stored.valuesHeldType] : []);
	const valuesHeldTypes = orderValuesHeldTypes(storedTypes);
	const legacyNumberFormat =
		stored.showSummarized === false
			? CAP_TABLE_NUMBER_FORMAT.FULL
			: DEFAULT_CAP_CHART_SETTINGS.numberFormat;

	return {
		valueDisplayMode: stored.valueDisplayMode ?? DEFAULT_CAP_CHART_SETTINGS.valueDisplayMode,
		valuesHeldTypes: valuesHeldTypes.length
			? valuesHeldTypes
			: DEFAULT_CAP_CHART_SETTINGS.valuesHeldTypes,
		numberFormat: stored.numberFormat ?? legacyNumberFormat,
	};
};
